// File: src/components/OmniCine/Timeline/Clips/useRangeGlow.ts
import { useEffect } from "react";

export function useRangeGlowStyles() {
  useEffect(() => {
    const id = "oc-range-glow-styles";
    if (document.getElementById(id)) return;
    const style = document.createElement("style");
    style.id = id;
    style.textContent = `
      @keyframes ocRangeGlow {
        0%   { --ocA: .25; --ocB: .10; }
        50%  { --ocA: .55; --ocB: .18; }
        100% { --ocA: .25; --ocB: .10; }
      }
      .oc-rangeSel { position: relative; isolation: isolate; }
      .oc-rangeSel::before {
        content: ""; position: absolute; inset: 1px; border-radius: 0.5rem;
        background:
          radial-gradient(120% 120% at 15% 10%, rgba(var(--oc-c0, 34 211 238), var(--ocB, .12)), transparent 60%),
          radial-gradient(120% 120% at 85% 90%, rgba(var(--oc-c1, 168 85 247), var(--ocB, .12)), transparent 60%);
        pointer-events: none; z-index: 0;
        animation: ocRangeGlow 1800ms cubic-bezier(.45,.05,.35,.95) infinite;
      }
      .oc-rangeSel::after {
        content: ""; position: absolute; inset: -1px; border-radius: 0.5rem; padding: 1px;
        background:
          conic-gradient(from 0deg,
            rgba(var(--oc-c0, 34 211 238), var(--ocA, .45)) 0deg,
            rgba(var(--oc-c1, 168 85 247), var(--ocA, .45)) 120deg,
            rgba(var(--oc-c0, 34 211 238), var(--ocA, .45)) 360deg);
        -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
        -webkit-mask-composite: xor; mask-composite: exclude;
        pointer-events: none; z-index: 1;
        animation: ocRangeGlow 1800ms cubic-bezier(.45,.05,.35,.95) infinite;
      }
      @media (prefers-reduced-motion: reduce) {
        .oc-rangeSel::before, .oc-rangeSel::after { animation: none !important; }
      }
    `;
    document.head.appendChild(style);
  }, []);

  // theme vars (cyan/violet RGB channels)
  return {
    ["--oc-c0" as any]: "34 211 238",  // cyan-400
    ["--oc-c1" as any]: "168 85 247",  // violet-500
  } as React.CSSProperties;
}

